module.exports = __webpack_public_path__ + "img/logo.ros.9438bdb4.png";